import { useRef } from "react";
import { IVisibilidad } from "../../Interfaces/IEquipo";
import {
  IFilterTableEquipo,
  IPostCrearEquipo,
} from "../../Interfaces/ListaVerificacion/Equipo/IEquiposCheckList";
import { fetchListVerificacion } from "../http-common";


const PostCrearEquipo = (data: IPostCrearEquipo) => {
  return fetchListVerificacion.post("Equipo/CrearEquipo", data);
};

const PostLitarTablaEquipo = (filter: IFilterTableEquipo) => {
  return fetchListVerificacion.post("Equipo/ListarTable", filter);
};

const PostListarTablaEquipoPorModelo = (filter: any) => {
  return fetchListVerificacion.post(
    "Equipo/ListarTableEquipoPorModelo",
    filter
  );
};

const PostListarComboEquipoPorModeloId = (
  request: any,
  controller = new AbortController()  
) => {
  return fetchListVerificacion.post("Equipo/ListarEquipoPorModeloId", request, { signal: controller.signal });
};

const EquipoActualizar = (body: any) => {
  return fetchListVerificacion.put(`Equipo/ActualizarNombre`, body);
};
const PutActualizarVisibilidad=(request:IVisibilidad)=>{
  return fetchListVerificacion.put("Equipo/ActualizarVisibilidad",request)
} 


const EquipoService = {
  PostCrearEquipo,
  PostLitarTablaEquipo,
  PostListarTablaEquipoPorModelo,
  PostListarComboEquipoPorModeloId,
  EquipoActualizar,
  PutActualizarVisibilidad
};

export default EquipoService;
